export enum AppLanguage {
    SPANISH = 'es',
    ENGLISH = 'en',
    FRENCH = 'fr',
    GERMAN = 'de',
}

export type AppLanguageType = AppLanguage;
